import React from "react";
import QmsPageShell from "./QmsPageShell";

/** Thin route wrapper — API probe only until full UI is implemented. */
const QmsScaffoldPage = ({ screenKey }) => (
  <QmsPageShell screenKey={screenKey} />
);

export default QmsScaffoldPage;
